import { Dispatch, SetStateAction, useState, VFC } from 'react'
import { MasterDataWithFieldType } from 'src/models/MasterData'
import {
  black,
  contributionGray,
  truewhite,
  _profilegreen,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled, { css } from 'styled-components'

export const SearchCheckboxFieldType: VFC<{
  title: string
  items?: MasterDataWithFieldType[]
  selectedItems: number[]
  setSelectedItems: Dispatch<SetStateAction<number[]>>
}> = ({ title, items, selectedItems, setSelectedItems }) => {
  const [opened, setOpened] = useState(true)
  const fieldTypes = Array.from(new Set(items && items.map((s) => s.fieldType)))
  const onChangeItems = (id: number, checked: boolean) => {
    if (checked) setSelectedItems([...selectedItems, id])
    else setSelectedItems(selectedItems.filter((item) => id !== item))
  }
  const onClearItems = () => {
    setSelectedItems([])
  }
  return (
    <SearchCheckboxFieldTypeContent>
      <SearchCheckboxFieldTypeHeader>
        <SearchCheckboxFieldTypeTitle
          opened={opened}
          onClick={() => setOpened(!opened)}
        >
          <label />
          {title}
        </SearchCheckboxFieldTypeTitle>
        {opened && selectedItems.length > 0 && (
          <SearchCheckboxFieldTypeClear onClick={() => onClearItems()}>
            選択を解除する
          </SearchCheckboxFieldTypeClear>
        )}
      </SearchCheckboxFieldTypeHeader>
      <Accordion opened={opened}>
        <SearchCheckboxFieldTypeItems>
          {fieldTypes.map((fieldType) => (
            <>
              <SearchCheckboxFieldTypeItemsTitle>
                {fieldType}
              </SearchCheckboxFieldTypeItemsTitle>
              {items &&
                items
                  .filter((item) => item.fieldType == fieldType)
                  .map((item) => {
                    const checked = selectedItems.some(
                      (si) => Number(item.value) === si,
                    )
                    return (
                      <SearchCheckboxFieldTypeItem
                        key={`${item.value}_${item.label}`}
                      >
                        <input
                          id={item.value}
                          type="checkbox"
                          onChange={({ target: { checked } }) =>
                            onChangeItems(Number(item.value), checked)
                          }
                          checked={checked}
                        />
                        <label htmlFor={item.value} key={item.label}>
                          {item.label}
                        </label>
                      </SearchCheckboxFieldTypeItem>
                    )
                  })}
            </>
          ))}
        </SearchCheckboxFieldTypeItems>
      </Accordion>
    </SearchCheckboxFieldTypeContent>
  )
}

const SearchCheckboxFieldTypeContent = styled.div`
  background: white;
  border-radius: 5px;
  margin: 10px 0px;
`
const SearchCheckboxFieldTypeHeader = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16.5px;
`

const SearchCheckboxFieldTypeClear = styled.div`
  margin-left: 8px;
  display: inline-block;
  font-size: 10px;
  font-weight: 400;
  color: ${contributionGray};
  text-decoration: underline;
  cursor: pointer;
`

const transitionTime = '0.2s'

const SearchCheckboxFieldTypeTitle = styled.div<{ opened: boolean }>`
  cursor: pointer;
  label {
    margin-left: 3px;
    margin-right: 12px;
  }
  label::before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    border-top: 6px solid ${black};
    border-right: 6px solid ${black};
    border-bottom: 6px solid transparent;
    border-left: 6px solid transparent;
    transform: rotate(45deg);
    transition: ${transitionTime};
    pointer-events: none;
  }
  ${({ opened }) =>
    opened &&
    css`
      label::before {
        transform: rotate(135deg);
      }
    `}
`

const Accordion = styled.div<{ opened: boolean }>`
  transition: ${transitionTime};
  ${({ opened }) =>
    opened
      ? css`
          max-height: 2000px;
          visibility: visible;
        `
      : css`
          max-height: 0px;
          visibility: hidden;
        `}
`

const SearchCheckboxFieldTypeItems = styled.div`
  margin: 0px 40px;
`
const SearchCheckboxFieldTypeItemsTitle = styled.div`
  font-size: 14px;
  margin: 8px 0px;
`

const SearchCheckboxFieldTypeItem = styled.div`
  display: inline-block;
  margin: 4px 4px;
  input {
    display: none;
  }

  input:checked + label {
    background: ${_profilegreen};
    color: ${truewhite};
  }

  label {
    display: inline-block;
    padding: 2px 16px;
    width: auto;
    color: ${_profilegreen};
    font-size: 14px;
    font-weight: ${fontWeightBold};
    text-align: center;
    border: 1px solid ${_profilegreen};
    border-radius: 28px;
    line-height: 28px;
    white-space: nowrap;
  }
`
